RivalIQ.apps.Alerts.module('enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    // as the filters are state dependent, we need to defer constructing the list until after state has
    // loaded (i.e., wait to see if the user has ads access).
    let alertFilters;
    enums.getAlertFilters = function () {
        if (!alertFilters) {

            const eventClass = RivalIQ.utils.companyEvents.eventClass;

            const names = {
                alertsAll: 'All Alerts',
                webPageSeo: 'Website Language Changes',
                alertsSocial: 'Social Bio Changes',
                engagementGrowth: 'Big Engagement Moves',
                audienceGrowth: 'Big Audience Moves',
                alertsLandscapeBreakoutPost: 'Breakout Posts',
                alertsPresenceChange: 'Social Handle Changes'
            };

            if (RivalIQ.state.account.channelDisplay(RivalIQ.enums.sources.FACEBOOK_ADS)) {
                names.alertsFacebookAds = 'Facebook Ads';
            }

            if (RivalIQ.state.account.get('plan').has_likely_promoted) {
                names.alertsLikelyBoostedPosts = 'Notable Likely Boosted Posts';
            }

            if (RivalIQ.state.account.channelDisplay(RivalIQ.enums.sources.INSTAGRAM)) {
                names.alertsInstagramLinkedSite = 'Instagram Bio Link Changes';
            }

            if (RivalIQ.state.account.get('plan').has_full_instant_search) {
                names.alertsListening = 'Social Listening Alerts';
            }

            alertFilters = _.mapValues(_.pick(eventClass, _.keys(names)), function (group, key) {
                return _.extend({
                    name: names[key],
                    eventClass: key
                }, group);
            });
        }

        return alertFilters;
    };

});
